var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "grid-outer" },
    [
      _c(
        "v-snackbar",
        {
          attrs: { timeout: "-1" },
          model: {
            value: _vm.displayToastMessage,
            callback: function ($$v) {
              _vm.displayToastMessage = $$v
            },
            expression: "displayToastMessage",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.toastText) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.title
        ? _c("div", { staticClass: "grid-title" }, [
            _c("p", { class: _vm.title.class }, [
              _vm._v("\n      " + _vm._s(_vm.title.value) + "\n    "),
            ]),
            _vm._v(" "),
            _vm.subTitle
              ? _c("p", { class: _vm.subTitle.class }, [
                  _vm._v("\n      " + _vm._s(_vm.subTitle.value) + "\n    "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.description
              ? _c("p", { class: _vm.description.class }, [
                  _vm._v("\n      " + _vm._s(_vm.description.value) + "\n    "),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid-actions" },
        [
          _c(
            "v-btn",
            {
              staticClass: "clear-filters",
              attrs: { size: "sm" },
              on: { click: _vm.clearFilters },
            },
            [_vm._v("\n      Clear filters\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "csv-export" },
            [
              _c(
                "v-btn",
                {
                  attrs: { size: "sm", disabled: _vm.exportLoading },
                  on: { click: _vm.handleServerExport },
                },
                [_vm._v("\n        Export as CSV\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid-wrapper" },
        [
          _c("ag-grid-vue", {
            ref: _vm.agGridID,
            staticClass: "ag-theme-alpine",
            staticStyle: { height: "100%" },
            style: _vm.gridStyles,
            attrs: {
              id: _vm.agGridID,
              "dom-layout": "normal",
              "column-defs": _vm.columnDefs,
              "row-model-type": "serverSide",
              "server-side-infinite-scroll": true,
              "cache-block-size": _vm.cacheBlockSize,
              "max-concurrent-datasource-requests": 4,
              "max-blocks-in-cache": 15,
              "pagination-page-size": _vm.paginationPageSize,
              pagination: _vm.map.isPagination,
              components: _vm.frameworkComponents,
              "grid-options": _vm.gridOptions,
              "loading-cell-renderer-selector": _vm.handleCellRenderer,
              modules: _vm.modules,
              context: _vm.context,
              "overlay-no-rows-template": _vm.overlayNoRowsTemplate,
            },
            on: {
              bodyScrollEnd: _vm.bodyScrollEnd,
              "grid-ready": _vm.onGridReady,
              "filter-changed": _vm.handleFilterChange,
              "column-resized": _vm.saveGridColumnState,
              "column-visible": _vm.saveGridColumnState,
              "column-moved": _vm.saveGridColumnState,
              "column-pinned": _vm.saveGridColumnState,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }